import React, { useEffect,   useState } from "react"
import { Footer } from "../shared/Footer"
import { SidebarMenu } from "../shared/SidebarMenu"
import { NavTopMenu } from "../shared/NavTopMenu"
import {  Tooltip} from "@material-ui/core"
import "../../styles/style.scss"
import { timeSessionDifference } from "../../constants/auth/timeSessionDifference"
import { actionErrorConnection } from "../../constants/component/actionErrorConnection"
import { sesionExpired } from "../../constants/auth/sesionExpired"
import { useDispatch, useSelector } from "react-redux"
import Swal from "sweetalert2"

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { validateAccessUser } from "../../constants/component/validateAccessUser"
import * as view from "../../constants/models/viewsList"
import { SYSTEM } from "../../constants/models/typeOperationRol"
import VideoScreen from "../../constants/customComponent/VideoScreen"
import { fetchImages } from "../../actions/images"
import { deleteVideoDispatch, } from "../../actions/videos"


export const IS_IMAGE = false
const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;


export function ContentVideoScreen(props) {
  
  const [responseArray, setResponseArray] = useState([])
  const [isLoadingDelete, setIsLoadingDelete] = useState(false)
  const sessionDifference = timeSessionDifference();
  const dispatch = useDispatch()
  const history = useHistory()
  const [currentVideo, setCurrentVideo] = useState(responseArray && responseArray.length ? responseArray[0] : null);

  
  const handleVideoSelect = (video) => {
    setCurrentVideo(video);
  };
    const swalCustomButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn custom-btn',
          cancelButton: 'btn custom-cancel-btn me-3'
        },
        buttonsStyling: false
      });
    const {user,isLoggedIn} = useSelector(state => state.auth)
    const {videos, isLoadingVideos,reload} = useSelector(state => state.videos)
    const operationRol = isLoggedIn ? user.operationRol : "---";

    useEffect(()=>{
        
     if(videos && videos.length > 0){
            setCurrentVideo(videos[0])
            setResponseArray(videos)
         // eslint-disable-next-line react-hooks/exhaustive-deps
        }else if (!videos && !isLoadingVideos && !reload) {

          dispatch(fetchImages(false))
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[videos])
    

    const deleteVideo =  async (fileName) =>{
      setIsLoadingDelete(true)
      swalCustomButtons.fire({
        title: 'Eliminar',
        html: `<span>Esta acción eliminará permanentemente el video</span> <span class="text-title-delete-file"> ${fileName}</span>`,
        icon: 'warning',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(deleteVideoDispatch(false,fileName ))
          .then(()=>{
              
              Swal.fire({
                icon: 'success',
                title: 'Video eliminado exitosamente',
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                }).then((result)=>{
                  if(result.isConfirmed){
                    props.history.push('/');
                  }
                })
                setIsLoadingDelete(false)
               
            })
            .catch((error) => {
              console.log(error);
              setIsLoadingDelete(false)
              if(sessionDifference > Number(tokenExpired)){
                sesionExpired(dispatch, history);
              } else{
                actionErrorConnection(error, 'Error al borrar video.');
              }
            });
        }
      }).finally(()=>{
        setIsLoadingDelete(false)
      })
      
    };

    const editVideo = (fileId) => {
      props.history.push(`/administration/content/video/update/${fileId}`);
      window.location.reload();
    };
    const createVideo = () => {
      props.history.push(`/administration/content/video/create`);
      
    };
      
  return (
    <>
      <div className="container-fluid p-0 m-0">
        <div className="row flex-nowrap p-0 m-0">
          <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
            <SidebarMenu />
          </div>
          <div className="col p-0 ms-1 me-1">
            <NavTopMenu />
            <div className="container ps-3 pe-3 container-size">
              <div className="row base-container">
                <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4  d-flex justify-content-between align-items-center">
                  <span>Contenido <i className="fas fa-angle-right ms-2 me-2"></i> Videos </span>
                  {validateAccessUser(view.CREATE_CONTENT, user) && operationRol === SYSTEM && (
                    <Tooltip title="Agregar Video">
                        <button onClick={createVideo} disabled={isLoadingDelete} className="btn custom-btn-icons"  >
                            <i className="fas fa-plus-square custom-icon-add"></i>
                        </button>
                    </Tooltip>
                  )}
                </div>
              </div>
              <div className="row base-container">
                <div className="col-md-4">
                  <div className="list-group">

                    {!isLoadingVideos && (responseArray && responseArray.length >0 ?
                      responseArray.map((video, index) => (
                        <div  key={index}>
                          <div
                             style={{backgroundColor:`${currentVideo && currentVideo.name === video.name ? '#4E64A0' : ''}`, color:`${currentVideo && currentVideo.name === video.name ? '#FFFFFF' : ''}`, cursor:"pointer"}}
                              className={`list-group-item d-flex justify-content-between list-group-item-action mb-2 `}
                              onClick={() => handleVideoSelect(video)}
                            >
                              {video.name}
                          {validateAccessUser(view.CREATE_CONTENT, user) && operationRol === SYSTEM && (
                          <div className="d-flex flex-row">
                            <Tooltip title="Editar" placement="top-start" arrow>
                              <button disabled={isLoadingDelete} onClick={() => editVideo(video.name)} className="btn-list custom-btn-icons ">
                                <i className="fas fa-edit" style={{ color: `${currentVideo && currentVideo.name === video.name ? "#FFFFFF":"#4E64A0"}` }}></i>
                              </button>
                            </Tooltip>
                            <Tooltip title="Eliminar" placement="top-start" arrow>
                              <button disabled={isLoadingDelete} style={{ color: `${currentVideo && currentVideo.name === video.name ? "#EA5656":"#E52D2D"}`}} onClick={() => deleteVideo(video.name)} className="btn-list ">
                                <i className="fas fa-trash"></i>
                              </button>
                            </Tooltip>
                          </div>
                        )}
                          </div>
                        </div>
                      ))
                      :
                      <div className="col-md-12">
                        <div className="w-100 element-row-message border-content-sections d-flex justify-content-center pt-5 pb-5">
                            <span>Documentos no disponibles</span>
                        </div>
                    </div>
                      )}
                  </div>

                </div>
                <div className="col-md-8 mb-2">
                  {currentVideo && !isLoadingVideos && (
                    <VideoScreen currentVideo={currentVideo}/>
                  ) }
                </div>
                { isLoadingVideos &&
                        <div className="col-md-12">
                            <div className="w-100 element-row-message custom-icon-loading border-content-sections d-flex justify-content-center pt-5 pb-5">
                                <i className="fas fa-spinner fa-spin"></i>
                            </div>
                        </div>

                    }
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}


ContentVideoScreen.propTypes = {
  history: PropTypes.object
}
